import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Skeleton from "@material-ui/lab/Skeleton";
import { Creators as CartActions } from "../../store/ducks/cart";
import { formatPrice } from "../../util/format";
import { ContainerCard, ContainerCartOrRemember, ContainerDatails, ContainerDetailsPromoName, ContainerDetailsPromoPrice, ContainerImage, ContainerInfo, ContainerManufacturer, ContainerPrice, ContainerPriceAndAddCart, ContainerPromo } from "./styles";
import { allowBuy } from "../../util/buy";
import { getIdealInfoPrice, temPrecoDeVenda } from "../../util/price";
import { precoNoPix } from "../../util/pixPrice";
import { selectDescontoPixDoContexto } from "../../store/ducks/deliveryContext";
import PixDiscountBadge from "../PixDiscountBadge";
import { PriceType } from "../../util/priceType";
import { productImageSrc, handleProductImageError } from "../../util/imageFallback";

const CardSale = ({ product, hasSelectedStore }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [imageLoaded, setImageLoaded] = useState(false);
    const { nome, imagens, estoque_loja, estoque_total, url, fabricante } = product;
    const hasStock = (hasSelectedStore && estoque_loja > 0) || (!hasSelectedStore && estoque_total > 0);
    // sem preço de venda (> 0) o produto aparece indisponível e não vai para a cesta
    const comPreco = temPrecoDeVenda(product.precos);
    const { loading: loadingItemInCart, productIdChanged } = useSelector(state => state.cart);
    const descontoPix = useSelector(selectDescontoPixDoContexto, shallowEqual);
    const { programa_fidelidade = false } = useSelector((state) =>
        state.user.profile == null ? false : state.user.profile
    );
    const viewProductDetails = () => {
        history.push(`/produtos/visualizar/${url}`);
    }

    function addToCart(product) {
        dispatch(CartActions.addProduct(product));
    }

    function actionContainerCartOrRemember() {
        if (hasStock && comPreco) {
            addToCart(product);
        } else {
            /*Implementação avise-me*/
        }
    }

    const { priceOf, priceBy, discount, alternativePrices, lowestAlternativePrice } = getIdealInfoPrice(product.precos, programa_fidelidade);
    // Preço no Pix da farmácia do contexto; sem farmácia conhecida, "até X% OFF no Pix" (P-113)
    const pixPrice = descontoPix.conhecida ? precoNoPix(priceBy, descontoPix.perc) : null;
    const isTakeMorePayLess = lowestAlternativePrice?.type === PriceType.TAKEMOREPAYLESS &&
        lowestAlternativePrice?.takeQuantity &&
        lowestAlternativePrice?.payQuantity;

    return (
        <ContainerCard>
            <ContainerImage onClick={viewProductDetails}>
                {!imageLoaded && (
                    <Skeleton variant="rect" animation="wave" width="100%" height="100%" style={{ position: 'absolute', top: 0, left: 0, borderRadius: 8 }} />
                )}
                <img
                    src={productImageSrc(product)}
                    onError={handleProductImageError(product)}
                    alt={nome.toLowerCase()}
                    title={nome.toLowerCase()}
                    onLoad={() => setImageLoaded(true)}
                    style={{ opacity: imageLoaded ? 1 : 0 }}
                />
                {hasStock && discount > 0 && (
                    <ContainerPromo>
                        <span>
                            {parseFloat(discount)
                                .toString()
                                .replace(".", ",")}
                            % OFF
                        </span>
                    </ContainerPromo>
                )}
                <ContainerDatails className={hasStock ? (alternativePrices && alternativePrices.length > 0 ? "promo-pague-mais-leve-menos" : "item-sale") : "zero-stock"}>
                    {hasStock && alternativePrices && alternativePrices.length > 0 && lowestAlternativePrice ? (
                        <>
                            <ContainerDetailsPromoName>
                                <span>{isTakeMorePayLess ? `Leve ${lowestAlternativePrice.takeQuantity} pague ${lowestAlternativePrice.payQuantity}` : "Leve mais:"}</span>
                            </ContainerDetailsPromoName>
                            <ContainerDetailsPromoPrice>
                                <span><strong>{formatPrice(lowestAlternativePrice.priceBy)}</strong> cada</span>
                            </ContainerDetailsPromoPrice>
                        </>
                    ) : (
                        <span>{hasStock ? "Detalhes" : "Produto sem estoque!"}</span>
                    )}
                </ContainerDatails>
            </ContainerImage>

            <ContainerInfo>
                {fabricante && (
                    <ContainerManufacturer>
                        <span>{fabricante}</span>
                    </ContainerManufacturer>
                )}
                <h3>{nome}</h3>
                {hasStock && !comPreco && (
                    <ContainerPriceAndAddCart>
                        <ContainerPrice>
                            <span className="other-price">Indisponível no momento</span>
                        </ContainerPrice>
                    </ContainerPriceAndAddCart>
                )}
                {hasStock && comPreco && (
                    <ContainerPriceAndAddCart>
                        <ContainerPrice>
                            {priceOf !== priceBy ? (
                                <span className="old-price">{formatPrice(parseFloat(priceOf))}</span>
                            ) : null}
                            {pixPrice !== null ? (
                                <>
                                    <span className="price">{formatPrice(pixPrice)} <span className="pix-label">no Pix</span></span>
                                    <span className="other-price">ou {formatPrice(parseFloat(priceBy))}</span>
                                </>
                            ) : (
                                <span className="price">{formatPrice(parseFloat(priceBy))}</span>
                            )}
                            {!descontoPix.conhecida && descontoPix.percMax > 0 && (
                                <span className="pix-hint">
                                    <PixDiscountBadge perc={descontoPix.percMax} ate small />
                                </span>
                            )}
                        </ContainerPrice>
                        {allowBuy(hasSelectedStore, estoque_total, estoque_loja) && (
                            <ContainerCartOrRemember style={{ opacity: loadingItemInCart ? 0.5 : 1 }} onClick={loadingItemInCart ? undefined : actionContainerCartOrRemember}>
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
                                </svg>
                                <span>{productIdChanged === product.id && loadingItemInCart ? "Adicionando..." : "Comprar"}</span>
                            </ContainerCartOrRemember>
                        )}
                    </ContainerPriceAndAddCart>
                )}
            </ContainerInfo>
        </ContainerCard>
    );
};

export default CardSale;
